import { Stopover } from '../../../types';
import { DocumentsConsentsDescriptionV2 } from './documentsConsentsDescriptionV2';

type DocumentsConsentsDataV2Props = {
  activeKey: string | string[];
  onOpenPanel: (panel: string | string[]) => void;
  selectedStopover: Stopover;
  setSelectedStopover?: (stopover: Stopover) => void;
};
export function DocumentsConsentsDataV2(props: DocumentsConsentsDataV2Props) {
  const { activeKey, onOpenPanel, selectedStopover, setSelectedStopover } =
    props;

  return (
    <DocumentsConsentsDescriptionV2
      activeKey={activeKey}
      onOpenPanel={onOpenPanel}
      selectedStopover={selectedStopover}
      setSelectedStopover={setSelectedStopover}
    />
  );
}
